import { computed, onMounted, onUnmounted, ref } from 'vue';

export default function useResponsive() {
  const width = ref(window.innerWidth);
  const height = ref(window.innerHeight);
  const isMobile = computed(() => width.value < 1200);
  const isSmallerThan350Px = computed(() => width.value < 350);

  const updateSize = () => {
    width.value = window.innerWidth;
    height.value = window.innerHeight;
  };

  onMounted(() => {
    window.addEventListener('resize', updateSize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateSize);
  });

  return {
    width,
    height,
    isMobile,
    isSmallerThan350Px,
  };
}
